export const scrollToElement = (id: string) => {
  const element = document.getElementById(id);
  if (!element) {
    return;
  }
  const offset = 45;
  const bodyRect = document.body.getBoundingClientRect().top;
  const elementRect = element.getBoundingClientRect().top;
  const elementPosition = elementRect - bodyRect;
  const offsetPosition = elementPosition - offset;
  window.scrollTo({
    behavior: "smooth",
    top: offsetPosition,
  });
};
